import SmarteditController from '@/utils/Controllers/SmarteditController';

export default async () => {
  const entries = SmarteditController.getEditorialEntries(
    '.js-del-contentcards',
  );
  if (entries.length > 0) {
    const controller = await import(
      /* webpackChunkName: "DELContentCardsController-lib" */ '@/delonghi/Controllers/DELContentCards/DELContentCardsController'
    );
    controller.default();
  }
};
